{
  "entities": {
    "warehouses": "倉庫 | 倉庫",
    "loadtypes": "荷物の種類 | 荷物の種類",
    "organizations": "組織 | 組織",
    "orgs": "組織 | 組織"
  }
}
